export default __webpack_public_path__ + "static/1.1_DE-c178a677e0f778aea5037decc3ebee6f.png";